// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor1 from '@/game/prefabs/World/Mentors/Mentor1';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level2 extends TilemapScene {
  constructor() {
    super('Level2');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // forest_biome_2
    const forest_biome_2 = this.add.tilemap('forest-biome-2');
    forest_biome_2.addTilesetImage('summer forest', 'summer forest');
    forest_biome_2.addTilesetImage('summer 32x32', 'summer 32x32');
    forest_biome_2.addTilesetImage('summer 16x32', 'summer 16x32');
    forest_biome_2.addTilesetImage('summer 48x32', 'summer 48x32');
    forest_biome_2.addTilesetImage(
      'summer trees 80x112',
      'summer trees 80x112',
    );
    forest_biome_2.addTilesetImage('collision', 'collision & alpha');

    // ground___summer_forest_1
    forest_biome_2.createLayer(
      'Ground - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // ground_deco___summer_forest_1
    forest_biome_2.createLayer(
      'Ground deco - summer forest',
      ['summer forest'],
      0,
      0,
    );

    // objects_1___summer_forest_1
    forest_biome_2.createLayer(
      'Objects 1 - summer forest',
      ['summer forest', 'summer 48x32', 'summer 16x32'],
      0,
      0,
    );

    // tOP___summer_forest_1
    forest_biome_2.createLayer('TOP - summer forest', ['summer forest'], 0, 0);

    // cOLLISION_1
    const cOLLISION_1 = forest_biome_2.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 24, 126);
    this.add.existing(player);

    // portal
    const portal = new Portal(this, 707, 118);
    this.add.existing(portal);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 105, 159);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 303, 122);
    this.add.existing(worldNode_5);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 213, 298);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 389, 436);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 628, 337);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 597, 58);
    this.add.existing(worldNode_9);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 200, 192);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 99, 53);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 279, 49);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(this, 720, 81);
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(this, 743, 243);
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(this, 705, 348);
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(this, 472, 496);
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(this, 39, 496);
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(this, 3, 409);
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      22,
      360,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(this, 44, 51, 'summer_trees_sheet', 0);
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      230,
      88,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      559,
      45,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      751,
      56,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      753,
      396,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      443,
      540,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      98,
      478,
      'summer_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      91,
      303,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      422,
      67,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      516,
      168,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      403,
      344,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      740,
      302,
      'summer_trees_sheet',
      2,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(this, 312, 240, 'summer 48x', 1);
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(this, 319, 224, 'summer 48x', 1);
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(this, 441, 255, 'summer 48x', 1);
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(this, 456, 385, 'summer 48x', 1);
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(this, 337, 176, 'summer 32x', 1);
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(this, 335, 128, 'summer 32x', 1);
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(this, 304, 112, 'summer 32x', 1);
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(this, 336, 96, 'summer 32x', 1);
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(this, 304, 80, 'summer 32x', 1);
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(this, 320, 64, 'summer 32x', 1);
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(this, 368, 79, 'summer 32x', 1);
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(this, 369, 33, 'summer 32x', 1);
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(this, 400, 64, 'summer 32x', 1);
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(this, 447, 64, 'summer 32x', 1);
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(this, 400, 112, 'summer 32x', 1);
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(this, 384, 144, 'summer 32x', 1);
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(this, 400, 176, 'summer 32x', 1);
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(this, 431, 144, 'summer 32x', 1);
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(this, 448, 112, 'summer 32x', 1);
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(this, 464, 96, 'summer 32x', 1);
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(this, 447, 64, 'summer 32x', 1);
    this.add.existing(forestTree_41);

    // forestTree_42
    const forestTree_42 = new ForestTree1(this, 480, 32, 'summer 32x', 1);
    this.add.existing(forestTree_42);

    // forestTree_43
    const forestTree_43 = new ForestTree1(this, 527, 64, 'summer 32x', 1);
    this.add.existing(forestTree_43);

    // forestTree_44
    const forestTree_44 = new ForestTree1(this, 560, 96, 'summer 32x', 1);
    this.add.existing(forestTree_44);

    // forestTree_45
    const forestTree_45 = new ForestTree1(this, 545, 144, 'summer 32x', 1);
    this.add.existing(forestTree_45);

    // forestTree_46
    const forestTree_46 = new ForestTree1(this, 481, 160, 'summer 32x', 1);
    this.add.existing(forestTree_46);

    // forestTree_47
    const forestTree_47 = new ForestTree1(this, 495, 192, 'summer 32x', 1);
    this.add.existing(forestTree_47);

    // forestTree_48
    const forestTree_48 = new ForestTree1(this, 528, 208, 'summer 32x', 1);
    this.add.existing(forestTree_48);

    // forestTree_49
    const forestTree_49 = new ForestTree1(this, 640, 192, 'summer 32x', 1);
    this.add.existing(forestTree_49);

    // forestTree_50
    const forestTree_50 = new ForestTree1(this, 512, 272, 'summer 32x', 1);
    this.add.existing(forestTree_50);

    // forestTree_51
    const forestTree_51 = new ForestTree1(this, 16, 64, 'summer 32x', 4);
    this.add.existing(forestTree_51);

    // forestTree_52
    const forestTree_52 = new ForestTree1(this, 176, 32, 'summer 32x', 4);
    this.add.existing(forestTree_52);

    // forestTree_53
    const forestTree_53 = new ForestTree1(this, 416, 256, 'summer 32x', 4);
    this.add.existing(forestTree_53);

    // forestTree_54
    const forestTree_54 = new ForestTree1(this, 304, 320, 'summer 32x', 4);
    this.add.existing(forestTree_54);

    // forestTree_55
    const forestTree_55 = new ForestTree1(this, 256, 352, 'summer 32x', 4);
    this.add.existing(forestTree_55);

    // forestTree_56
    const forestTree_56 = new ForestTree1(this, 320, 368, 'summer 32x', 4);
    this.add.existing(forestTree_56);

    // forestTree_57
    const forestTree_57 = new ForestTree1(this, 288, 384, 'summer 32x', 4);
    this.add.existing(forestTree_57);

    // forestTree_58
    const forestTree_58 = new ForestTree1(this, 160, 416, 'summer 32x', 4);
    this.add.existing(forestTree_58);

    // forestTree_59
    const forestTree_59 = new ForestTree1(this, 208, 464, 'summer 32x', 4);
    this.add.existing(forestTree_59);

    // forestTree_60
    const forestTree_60 = new ForestTree1(this, 320, 464, 'summer 32x', 4);
    this.add.existing(forestTree_60);

    // forestTree_61
    const forestTree_61 = new ForestTree1(this, 352, 416, 'summer 32x', 4);
    this.add.existing(forestTree_61);

    // forestTree_62
    const forestTree_62 = new ForestTree1(this, 464, 352, 'summer 32x', 4);
    this.add.existing(forestTree_62);

    // forestTree_63
    const forestTree_63 = new ForestTree1(this, 592, 448, 'summer 32x', 4);
    this.add.existing(forestTree_63);

    // forestTree_64
    const forestTree_64 = new ForestTree1(this, 544, 464, 'summer 32x', 4);
    this.add.existing(forestTree_64);

    // forestTree_65
    const forestTree_65 = new ForestTree1(this, 160, 240, 'summer 32x', 5);
    this.add.existing(forestTree_65);

    // forestTree_66
    const forestTree_66 = new ForestTree1(this, 208, 336, 'summer 32x', 5);
    this.add.existing(forestTree_66);

    // forestTree_67
    const forestTree_67 = new ForestTree1(this, 272, 320, 'summer 32x', 5);
    this.add.existing(forestTree_67);

    // forestTree_68
    const forestTree_68 = new ForestTree1(this, 480, 304, 'summer 32x', 5);
    this.add.existing(forestTree_68);

    // forestTree_69
    const forestTree_69 = new ForestTree1(this, 560, 416, 'summer 32x', 5);
    this.add.existing(forestTree_69);

    // forestTree_70
    const forestTree_70 = new ForestTree1(this, 80, 80, 'summer 32x', 2);
    this.add.existing(forestTree_70);

    // forestTree_71
    const forestTree_71 = new ForestTree1(this, 128, 64, 'summer 32x', 2);
    this.add.existing(forestTree_71);

    // forestTree_72
    const forestTree_72 = new ForestTree1(this, 176, 80, 'summer 32x', 2);
    this.add.existing(forestTree_72);

    // forestTree_73
    const forestTree_73 = new ForestTree1(this, 656, 224, 'summer 32x', 2);
    this.add.existing(forestTree_73);

    // forestTree_74
    const forestTree_74 = new ForestTree1(this, 624, 272, 'summer 32x', 2);
    this.add.existing(forestTree_74);

    // mentor
    const mentor = new Mentor1(this, 56, 90);
    this.add.existing(mentor);

    // worldNode
    const worldNode = new WorldNode(this, 645, 158);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 533, 311);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 336, 314);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 196, 409);
    this.add.existing(worldNode_3);

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 1;
    worldNode_4.NPCId = 5;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 1;
    worldNode_5.NPCId = 4;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 1;
    worldNode_6.NPCId = 3;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 1;
    worldNode_7.NPCId = 2;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 1;
    worldNode_8.NPCId = 1;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 1;
    worldNode_9.NPCId = 0;

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 1;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 1;
    worldNode_1.NPCId = 0;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 1;
    worldNode_2.NPCId = 0;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 1;
    worldNode_3.NPCId = 0;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.forest_biome_2 = forest_biome_2;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor1;
  private forest_biome_2!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.forest_biome_2,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
